import i18n from './service';

export { I18nLoader } from './loader';
export default i18n;
